import React, { memo } from 'react';
import type { FunctionComponent } from 'react';
import { Modal } from '@shared-components';
import { ModalTemplate, Button } from '@web-components-proxy';

interface DiscardChangesModalProps {
	isOpen: boolean;
	cancelLabel: string;
	confirmLabel: string;
	title: string;
	text: string;
	closeCancelAction: () => void;
	closeConfirmAction: () => void;
}

export const DiscardChangesModal: FunctionComponent<DiscardChangesModalProps> = memo(
	({ isOpen, title, text, cancelLabel, confirmLabel, closeCancelAction, closeConfirmAction }) => (
		<Modal isOpen={isOpen} onCasClosed={closeCancelAction}>
			<ModalTemplate mode="warning" hide-header-icon>
				<p slot="header-title">{title}</p>
				<p className="modal-content">{text}</p>
				<Button onCasClick={closeCancelAction} slot="footer-content" design="secondary" size="medium">
					{cancelLabel}
				</Button>
				<Button onCasClick={closeConfirmAction} slot="footer-content" design="primary" size="medium">
					{confirmLabel}
				</Button>
			</ModalTemplate>
		</Modal>
	),
);
